import './index_web.css';
import moment from 'moment';
import { convertToDollars, RoundedOffAmount } from '../../utilities/helper';
import Constants from '../../constants';
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import useTheme from '../../utilities/hooks/theme';

interface Props {
  item: any;
  isWithdraw?: boolean;
  statusText: any;
  statusColor: any;
}

const TransactionItemWeb = ({ item, statusColor, statusText }: Props) => {
  const { AccountTheme: theme } = useTheme();
  const {
    amount = 0,
    createdOn = '',
    purpose = '',
    gateway = '',
    transactionId = '',
    status = '',
    _id = '',
    modifiedOn
  } = item;

  const newAmount = RoundedOffAmount(amount);
  const col3Style = {
    background: theme.transactionHistoryDefaultCol3Bg,
    boxShadow: theme.transactionHistoryDefaultCol3BoxShadow,
    borderRight: `1px solid ${theme.transactionHistoryBorder}`
  };

  const col1Style = {
    background: theme.transactionHistoryDefaultColBg,
    boxShadow: theme.transactionHistoryDefaultColBoxShadow,
    borderRight: `1px solid ${theme.transactionHistoryBorder}`
  };
  const col2Style = {
    background: theme.transactionHistoryDefaultColBg,
    boxShadow: theme.transactionHistoryDefaultColBoxShadow,
    borderRight: `1px solid ${theme.transactionHistoryBorder}`
  };
  const col4Style = {
    background: theme.transactionHistoryDefaultColBg,
    boxShadow: theme.transactionHistoryDefaultColBoxShadow
  };
  const surfaceStyle = {
    border: `1px solid ${theme.transactionHistoryBorder}`
  };

  const detailsContainerStyle = {
    background: theme.transactionHistoryDefaultColBg,
    boxShadow: theme.transactionHistoryDefaultColBoxShadow,
    border: `1px solid ${theme.transactionHistoryBorder}`
  };

  const statusContainerStyle = {
    background: theme.transactionHistoryStatusContainerBg,
    boxShadow: theme.transactionHistoryStatusContainerBoxShadow,
    border: `2px solid ${theme.transactionHistoryBorder}`
  };
  const statusItemNameStyle = {
    background: theme.transactionHistoryStatusItemBg,
    color: theme.transactionHistoryStatusItemTextColor
  };
  return (
    <>
      <div className="transactionItem__wrapper__web" key={_id}>
        <div className="transactional_table_cell" style={surfaceStyle}>
          <div className="transactional_table_cell_col1" style={col1Style}>
            {' '}
            {moment(new Date(createdOn || modifiedOn), 'YYYY-MM-DD').format('DD-MM-YYYY')}
          </div>
          <div className="transactional_table_cell_col2" style={col2Style}>
            {' '}
            {moment(new Date(createdOn || modifiedOn), 'HH:mm').format('HH:mm')}
          </div>
          <div className="transactional_table_cell_col3" style={col3Style}>
            {
              <img
                className="transaction_status_indicator_img"
                src={
                  status == 'success' || status === 'accepted'
                    ? Constants.Images.successIndicator
                    : Constants.Images.failureIndicator
                }
              />
            }
            <p className="font_weight_800" style={{ color: statusColor }}>
              {' '}
              {statusText}
            </p>
          </div>
          <div className="transactional_table_cell_col4" style={col4Style}>
            <img style={{ width: '40px' }} src={Constants.Images.Wallet} />{' '}
            <p>
              {status === 'expired'
                ? `- ${convertToDollars(newAmount)}`
                : `${convertToDollars(newAmount)}`}
            </p>
          </div>
        </div>
        <Tooltip
          placement="top"
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: 'transparent'
              }
            }
          }}
          title={
            <div className="transactional_table_status_container" style={statusContainerStyle}>
              <div className="transactionTable__statusItem__wrapper">
                <p className="transactional_table_item_name" style={statusItemNameStyle}>
                  Status :
                </p>
                <p className="transactional_table_item_status">{status ? status : 'NA'}</p>
              </div>

              <div className="transactionTable__statusItem__wrapper">
                <p className="transactional_table_item_name" style={statusItemNameStyle}>
                  Transaction ID :
                </p>
                <p className="transactional_table_item_status">
                  {transactionId ? transactionId : 'NA'}
                </p>
              </div>

              <div className="transactionTable__statusItem__wrapper">
                <p className="transactional_table_item_name" style={statusItemNameStyle}>
                  Purpose :
                </p>
                <p className="transactional_table_item_status">{purpose ? purpose : 'NA'}</p>
              </div>
              <div className="transactionTable__statusItem__wrapper">
                <p className="transactional_table_item_name" style={statusItemNameStyle}>
                  Gateway :
                </p>
                <p className="transactional_table_item_status">{gateway ? gateway : 'NA'}</p>
              </div>
            </div>
          }>
          <div className="transactional_table_details_container" style={detailsContainerStyle}>
            <Constants.Svgs.Info color={'#f2f2f2'} />
            <p>Details</p>
          </div>
        </Tooltip>
      </div>
    </>
  );
};
export default React.memo(TransactionItemWeb);
